import * as React from 'react';

const ChevronDown = (props: any) => {
  return (
    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1.19995 1.59998L6.0027 6.39998L10.8 1.59997"
        stroke="stroke"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ChevronDown;
